export enum FAILURE_TELEMETRY_TYPE {
    unexpectedError = 'unexpectedError',
    userCorrectable = 'userCorrectable',
}
